import React from 'react';
import { Collapse } from 'antd';
import styled from '@emotion/styled';
import { LogoOnCourse, LogoMyTMPlus, LogoMyBag } from '../../../assets';
import { MyTMPlusTable } from './MyTMPlusTable';
import { GolfProfileTable } from './GolfProfileTable';
import { WITBTable } from './WITBTable';
import { CDMTable } from './CDMTable';
import { OnCourseTable } from './OnCourseTable';

export const UserProfileContent = (prop: any) => {
  const { userProfile, setRefresh, setIsLoading } = prop;
  const { Panel } = Collapse;

  return (
    <>
      <StyledContainer expandIconPosition="right" defaultActiveKey={['1']}>
        <Panel header={<img src={LogoMyTMPlus} alt="myTM+" />} className="myTm-logo" key="1">
          <MyTMPlusTable userProfile={userProfile} setRefresh={setRefresh} setIsLoading={setIsLoading} />
        </Panel>
      </StyledContainer>
      <StyledContainer expandIconPosition="right">
        <Panel header="Golf Profile" key="2">
          <GolfProfileTable userProfile={userProfile} />
        </Panel>
      </StyledContainer>
      <StyledContainer expandIconPosition="right">
        <Panel header={<img src={LogoOnCourse} alt="myCourse" />} className="onCourse-logo" key="3">
          <OnCourseTable userProfile={userProfile} />
        </Panel>
      </StyledContainer>
      <StyledContainer expandIconPosition="right">
        <Panel header="CDM Metadata" key="4">
          <CDMTable userProfile={userProfile} />
        </Panel>
      </StyledContainer>
      <StyledContainer expandIconPosition="right">
        <Panel
          header={
            <div className="d-flex align-items-center">
              <div>WITB</div>
              <img src={LogoMyBag} alt="myBag" />
            </div>
          }
          key="5"
        >
          <WITBTable userProfile={userProfile} />
        </Panel>
      </StyledContainer>
    </>
  );
};

const StyledContainer = styled(Collapse)`
  &.ant-collapse {
    margin-bottom: 5px;
  }
  .ant-collapse-header {
    font-weight: 500;
    font-size: 23px;
  }
  .myTm-logo > div > img {
    height: 40px;
    width: auto;
  }

  .onCourse-logo > div > img {
    height: 43px;
    width: auto;
  }
`;
